import React, { useEffect, useState } from "react";
import TotalChargeableApiCallBarChart from "./TotalChargeableApiCallBarChart";
import useLogout from "../../common/useLogout";
import { getChargeableCalls, getTotalCalls } from "../../../queries/metrics";
import { kFormatter } from "../../helpers";
import OverviewSuccessRateBarChart from "./OverviewSuccessRateBarChart";

const OverviewTab = ({ cableApp, currentUser, application }) => {
  const [handleLogout] = useLogout();
  const [totalCalls, setTotalCalls] = useState("0");
  const [chargeableCalls, setChargeableCalls] = useState("0");

  useEffect(() => {
    const createTotalApiCall = (data) => {
      const message = kFormatter(data.message[0]?.datapoints[0] || 0);
      setTotalCalls(message);
    };
    const createChargeableCalls = (data) => {
      const message = kFormatter(data.message[0]?.datapoints[0] || 0);
      setChargeableCalls(message);
    };

    cableApp[`overview-${application.name}`] =
      cableApp.cable.subscriptions.create(
        {
          channel: "ApplicationsChannel",
          chart_resource: "application-overview",
          id: application.id,
        },
        {
          connected: () => {
            getTotalCalls({
              id: application.id,
              service_name: "*",
              chart_resource: "application-overview",
            });
            if (currentUser.type === "Admin") {
              getChargeableCalls({
                id: application.id,
                service_name: "*",
                chart_resource: "application-overview",
              });
            }
          },
          received: (data) => {
            if (data.endpoint === "total_api_calls") {
              createTotalApiCall(data);
            } else {
              createChargeableCalls(data);
            }
          },
          rejected: () => {
            handleLogout();
          },
        }
      );
    return () => {
      cableApp[`overview-${application.name}`].unsubscribe();
    };
  }, []);

  return (
    <div id="overview" className="tab-pane active w-100">
      {/* <h4 className="mb-4">Overview</h4> */}
      <div className="d-flex align-items-end flex-wrap ml-n3">
        {/* <div className="px-3 mb-3">
          <label className="label-sm">TOTAL CALLS</label>
          <div className="text-xlg text-center">
            <strong>{totalCalls}</strong>
          </div>
        </div> */}
        {/* {currentUser.type === "Admin" ? (
          <div className="px-3 mb-3">
            <label className="label-sm">CHARGEABLE CALLS</label>
            <div className="text-xlg text-center">
              <strong>{chargeableCalls}</strong>
            </div>
          </div>
        ) : null} */}
        {/*<div className="px-3 mb-3">*/}
        {/*  <label className="label-sm">SUCCESS RATE</label>*/}
        {/*  <div className="text-xlg text-center text-success">*/}
        {/*    <strong>100%</strong>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>

      {/* <div className="row mt-5">
        <div className="col-12 col-lg-6 col-xl-5 mb-5">
          <h6 className="mb-4">
            {" "}
            {currentUser.type === "Admin"
              ? "Total/Chargeable API Calls"
              : "Total API Calls"}
          </h6>
          <TotalChargeableApiCallBarChart
            currentUser={currentUser}
            cableApp={cableApp}
            application={application}
          />
        </div>
        <div className="col-12 col-lg-6 col-xl-5 mb-5">
          <h6 className="mb-4">Success Rate</h6>
          <OverviewSuccessRateBarChart
            cableApp={cableApp}
            application={application}
          />
        </div>
      </div> */}
      <iframe
        src={application.iframeUrl}
        frameBorder={0}
        width={'99%'}
        height={3000}
      ></iframe>
    </div>
  );
};

OverviewTab.propTypes = {};

export default OverviewTab;
